import { HUImageDraft } from "@modules/dtos/imageDto"
import { HUImage } from "@modules/types/imageTypes"
import * as Yup from "yup"

export function getAvatartValidationSchema() {
  return Yup.object({
    avatar: Yup.mixed(),
  })
}

export const convertUserAvatarToFormik = (avatar?: HUImage): HUImageDraft => {
  return {
    serverBlurHash: avatar?.blurHash ?? "",
    serverPath: avatar?.path ?? "",
    localPath: undefined,
    localBase64: undefined,
  }
}
